export type CellLabelSide = 'pre' | 'suf'

export interface CellLabelShow {
  label: string
  color: string
  hollow: boolean
}

function isBlank(v: unknown): boolean {
  return v == null || String(v).trim() === ''
}

function ruleMatches(record: Record<string, unknown>, rule: any): boolean {
  if (!rule || isBlank(rule.field) || isBlank(rule.value)) {
    return false
  }
  return (record[rule.field] + '') === (rule.value + '')
}

function legacyRules(col: any, side: CellLabelSide) {
  if (side === 'pre') {
    return [{
      field: col.showPreLabel,
      value: col.showPreValue,
      label: col.preLabel,
      colColor: col.tagColor,
    }]
  }
  return [{
    field: col.showSufLabel,
    value: col.showSufValue,
    label: col.sufLabel,
    colColor: col.sufTagColor,
  }]
}

/** 解析某一侧要画在展示格上的标签（规则列表优先，否则旧单条）。 */
export function resolveCellSideLabels(col: any, record: any, side: CellLabelSide): CellLabelShow[] {
  if (!col) {
    return []
  }
  const flag = side === 'pre' ? col.preLabelFlag : col.sufLabelFlag
  if (flag !== true) {
    return []
  }
  const list = side === 'pre' ? col.preLabelRules : col.sufLabelRules
  const rules = (Array.isArray(list) && list.length > 0) ? list : legacyRules(col, side)
  const multi = side === 'pre' ? col.preMultiLabel : col.sufMultiLabel
  const sideHollow = side === 'pre' ? col.preHollowLabel === true : col.sufHollowLabel === true
  const matched: CellLabelShow[] = []
  const rec = record || {}
  for (const rule of rules) {
    if (!ruleMatches(rec, rule)) {
      continue
    }
    matched.push({
      label: (rule.label != null && String(rule.label) !== '') ? rule.label : '标签',
      color: rule.colColor || 'red',
      hollow: rule.hollow === true || (rule.hollow == null && sideHollow),
    })
    if (multi !== true) {
      break
    }
  }
  return matched
}

/** 实心走 Tag 的 color；空心不传 color，避免被填成实心底。 */
export function cellLabelTagBind(tag: CellLabelShow) {
  if (tag.hollow) {
    return {
      color: undefined,
      class: 'cell-affix-label-hollow',
      style: {
        color: tag.color,
        borderColor: tag.color,
        background: 'transparent',
      },
    }
  }
  return {
    color: tag.color,
  }
}
